const FALLBACK_ITEMS = [
  { label: 'LOA for Amazon FBA Approval' },
  { label: 'Amazon-Compliant Invoices' },
  { label: 'Direct U.S. Warehouse' },
  { label: 'High ROI / Low BSR Products' },
];

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

function TrustBar({ items }) {
  const displayItems = Array.isArray(items) && items.length > 0 ? items : FALLBACK_ITEMS;

  return (
    <div className="trust-bar">
      {displayItems.map((item, i) => (
        <div className="trust-item" key={item.id || i}>
          {item.icon ? (
            <span role="img" aria-hidden="true">
              {item.icon}
            </span>
          ) : (
            <CheckIcon />
          )}
          {item.label}
        </div>
      ))}
    </div>
  );
}

export default TrustBar;
